import { api } from './axios';
import { TagEntity } from '../interfaces/tag';
import { useTagStore } from '@/stores/tags.store';

const getTags = async () => {
  const tagsQuery = `query getTags { 
    tagList {
      nodes { 
        id 
        name
      } 
    } 
  }`;

  const tags = api
    .post('', {
      query: tagsQuery,
      operationName: 'getTags'
    })
    .then((res) => res.data.data.tagList.nodes as TagEntity[])
    .catch((res) => res.data);

  return tags;
};

const initializeTags = () => {
  const tagStore = useTagStore();

  getTags().then((res) => {
    tagStore.setTags(res);
  });
};

export { initializeTags };
